import { enumclass } from './enumclass'

const _YEAR = 365 * 24 * 60 * 60
// 当值大于1000年，表示无限
export const BALANCE_INFINITE = 1000 * _YEAR
// 无限时长/数量用2000年表示
export const AMOUNT_INFINITE = 2000 * _YEAR
export const INFINITE_TEXT = '♾️'

export function isInfinite(value) {
  return value >= BALANCE_INFINITE
}

export const BalanceChangeType = enumclass({
  INITIAL: 10, // 初始余额
  REDEEM_CODE: 11, // 兑换
  PAYMENT_SUBMIT: 12, // 简易充值
  PAYMENT_CONFIRM: 13, // 标准充值
  PAYMENT_REVERT: 14, // 撤销
  PAYMENT_REFUND: 15, // 退款
  CONSUMABLE_EXPENSE: 16, // 积分消费
  CONSUMABLE_INCOME: 17, // 积分收入
  TASK_INCREASE: 18, // 后台操作增加余额
  TASK_DECREASE: 19, // 后台操作减少余额
  TRANSFER_UPGRADE: 20, // 权益转换升级扣除
})

BalanceChangeType.isReverse = function isReverse(value) {
  return (
    value === BalanceChangeType.PAYMENT_REVERT ||
    value === BalanceChangeType.PAYMENT_REFUND ||
    value === BalanceChangeType.CONSUMABLE_EXPENSE ||
    value === BalanceChangeType.TASK_DECREASE ||
    value === BalanceChangeType.TRANSFER_UPGRADE
  )
}
